module.exports = __webpack_public_path__ + "assets/2ceac49f609db780a7e2b6f8dcbd74b1.png";